import { Typography } from "@mui/material";

export const CopyError = ({ errorMessage }: { errorMessage: string }) => {
  return <Typography color="error">{errorMessage || "An error occurred while copying the dashboard"}</Typography>;
};
